import { MsalService } from '@azure/msal-angular';

export function msalInitializer(msalService: MsalService) {
  return (): Promise<void> => msalService.instance.initialize();
}
